import React from 'react';
import { Trans, withTranslation, WithTranslation } from 'react-i18next';

import { Button } from '../../../../components/Buttons';
import EmptyState from '../../../../components/EmptyState';

import { P } from '../../../../components/Typography';
import { Allow } from '../../../../auth/accessToken';

import { Receipt } from '../../../../types/receipts';
import NoReceipts from './NoReceipts';

export interface ListMessageProps extends WithTranslation {
    q: string;
    receipts: Receipt[];
    isLoading: boolean;
    isLoadingNext: boolean;
    accountId: string;
    customerId: string;
    hasNext: boolean;
    refresh: () => void;
}

const ListMessage = (
    {
        t,
        receipts,
        isLoading,
        isLoadingNext,
        q,
        refresh,
    }: ListMessageProps
) => {
    if (isLoading || isLoadingNext) {
        return null;
    }
    if (!isLoading && receipts.length === 0 && q === '') {
        return (
            <Allow
                anyOfScopes={[['admin'], ['admin:accounts'], ['write:accounts', 'read:accounts'], ['accounts:admin']]}
                fallback={
                    <EmptyState>
                        <P>{t('customers.customers.empty_no_customers.message')}</P>
                    </EmptyState>
                }
            >
                <NoReceipts />
            </Allow>
        );
    }

    if (receipts.length === 0 && q !== '') {
        return (
            <EmptyState>
                <P>
                    <Trans i18nKey="customers.customer.receipts.empty_filtered_list.message" values={{ q }}>
                        Sorry, we can't find any customers matching <strong>{q}</strong>.
                    </Trans>
                </P>
                <Button onClick={() => refresh()}>
                    {t('customers.customer.receipts.empty_filtered_list.clear_search_and_filters')}
                </Button>
            </EmptyState>
        );
    }

    return null;
};

export default withTranslation()(ListMessage);
